import axios from "axios";

const GetIpController = {
  async GetIpUser() {
    try {
      const apiKey = '0d4e16a22ea289';
      const response = await axios.get(`https://ipinfo.io/json?token=${apiKey}`, {
        
      });
      return response.data.ip;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
};

export default GetIpController;